<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <v-card-title class="elevation-0">
          <span
            style="text-transform: uppercase"
            class="itemHeading"
            v-if="$route.query.name && $route.query.empid"
            >ATTENDANCE of {{ $route.query.name }} (Employee ID:
            {{ $route.query.empid }})</span
          >
          <span style="text-transform: uppercase" class="itemHeading" v-else
            >ATTENDANCE</span
          >
          <!-- <v-flex xs12 align-self-center py-2>
            <v-layout wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 xl3  pb-2>
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" outlined hide-details dense v-bind="attrs" v-on="on"
                      clearable class="rounded-xl"></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title type="month" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md3 lg2 xl2 pb-2 text-right>
                <v-btn
                  style="font-family: kumbhBold; text-transform: capitalize; font-size: 14px;"
                  dark
                  block
                  class="rounded-xl"
                  color="#005f32"
                  @click="eachEmployee()"
                >
                Excel Download
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex> -->
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <!-- Attendance Punch In/Punch Out -->
              <v-flex xs12 pt-5>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-card>
                      <v-layout wrap pa-5 justify-center>
                        <v-flex xs12>
                          <span
                            style="font-family: kumbhSemibold; font-size: 20px"
                            >{{ currentdate }}</span
                          >
                        </v-flex>
                        <v-flex xs12 py-5>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md8>
                              <v-layout wrap>
                                <v-flex xs12 sm6>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <v-btn color="#005f32" outlined rounded>
                                        <span
                                          style="
                                            font-family: kumbhBold;
                                            text-transform: none;
                                          "
                                          >Punch In</span
                                        >
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs12 pt-5 v-if="loginTime">
                                      <span style="font-family: kumbhBold">{{
                                        convertUTCToLocalForPunchIn(loginTime)
                                      }}</span>
                                    </v-flex>
                                    <v-flex xs12 pt-5 v-else>
                                      <span style="font-family: kumbhBold"
                                        >Not Marked</span
                                      >
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <v-btn color="#005f32" outlined rounded>
                                        <span
                                          style="
                                            font-family: kumbhBold;
                                            text-transform: none;
                                          "
                                          >Punch Out</span
                                        >
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs12 pt-5 v-if="logoutTime">
                                      <span style="font-family: kumbhBold">{{
                                        convertUTCToLocalForPunchIn(logoutTime)
                                      }}</span>
                                    </v-flex>
                                    <v-flex xs12 pt-5 v-else>
                                      <span style="font-family: kumbhBold"
                                        >Not Marked</span
                                      >
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6 md4 v-if="hourValue != 0">
                              <vue-ellipse-progress
                                :progress="value1"
                                :angle="-90"
                                color="green"
                                :size="100"
                                :thickness="10"
                                :legend="false"
                                :legendValue="0"
                                legendClass="legend-custom-style"
                                animation="reverse 700 400"
                                :noData="false"
                                :loading="false"
                                fontColor="red"
                                :half="false"
                                fontSize="5rem"
                              >
                                <!-- <span slot="legend-value">/200</span> -->
                                <p
                                  class="pt-5"
                                  slot="legend-caption"
                                  style="color: black; font-weight: bold"
                                >
                                  {{ hourValue }} hr
                                </p>
                              </vue-ellipse-progress>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout align-center justify-start>
                            <v-flex
                              xs12
                              sm6
                              text-start
                              v-if="
                                isLoggedin == false &&
                                isLoggedout == false &&
                                profile.onLeave == false
                              "
                            >
                              <v-btn
                                block
                                color="#005f32"
                                rounded
                                dark
                                @click="submit('login')"
                              >
                                <span style="font-family: kumbhSemibold"
                                  >Punch In</span
                                >
                              </v-btn>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              text-start
                              v-if="
                                isLoggedin == true &&
                                isLoggedout == false &&
                                profile.onLeave == false
                              "
                            >
                              <v-btn
                                block
                                color="#005f32"
                                rounded
                                dark
                                @click="submit('logout')"
                              >
                                <span style="font-family: kumbhSemibold"
                                  >Punch Out</span
                                >
                              </v-btn>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              text-start
                              v-if="profile.onLeave == true"
                            >
                              <v-btn block color="#005f32" rounded dark>
                                <span style="font-family: kumbhSemibold"
                                  >On Leave</span
                                >
                              </v-btn>
                            </v-flex>
                            <template>
                              <v-flex
                                xs12
                                sm2
                                align-self-center
                                text-end
                                v-if="
                                  isLoggedin == true &&
                                  isLoggedout == false &&
                                  attendanceData.description
                                "
                              >
                                <v-btn
                                  color="#005f32"
                                  rounded
                                  dark
                                  small
                                  @click="remarkdialogedit = true"
                                >
                                  <span
                                    style="
                                      font-family: kumbhBold;
                                      text-transform: none;
                                      color: white;
                                    "
                                    >Notes
                                    <v-icon small> mdi-pencil </v-icon></span
                                  >
                                </v-btn>
                              </v-flex>

                              <v-flex
                                xs12
                                sm2
                                align-self-center
                                text-end
                                v-if="
                                  isLoggedin == true &&
                                  isLoggedout == false &&
                                  !attendanceData.description
                                "
                              >
                                <v-btn
                                  color="#005f32"
                                  rounded
                                  dark
                                  small
                                  @click="remarkdialog = true"
                                >
                                  <span
                                    style="
                                      font-family: kumbhBold;
                                      text-transform: none;
                                      color: white;
                                    "
                                    >Notes
                                  </span>
                                </v-btn>
                              </v-flex>
                            </template>
                            <v-flex xs12 sm4 align-self-center text-left pl-10>
                              <v-btn outlined color="#005f32" rounded small to="/Troubleshoot/Report"
                                style="text-transform: none; border: 1px solid #005f32 !important;">
                                <span style="font-family: kumbhSemibold;">Troubleshoot</span>
                                <v-icon small right color="#005f32">mdi-help-circle-outline</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 sm6 text-start
                  v-if="isLoggedin == false && isLoggedout == false && profile.onLeave == false">
                  <v-btn block color="#005f32" rounded dark @click="submit('login')">
                    <span style="font-family: kumbhSemibold">Punch In</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 text-start
                  v-if="isLoggedin == true && isLoggedout == false && profile.onLeave == false">
                  <v-btn block color="#005f32" rounded dark @click="submit('logout')">
                    <span style="font-family: kumbhSemibold">Punch Out</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 text-start v-if="profile.onLeave == true">
                  <v-btn block color="#005f32" rounded dark>
                    <span style="font-family: kumbhSemibold">On Leave</span>
                  </v-btn>
                </v-flex> -->
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                sm3
                md3
                lg3
                xl3
                pa-1
                text-left
                style="font-family: poppinsregular"
              >
                <span style="font-family: kumbhRegular; font-size: 14px"
                  >Pick a date range</span
                >
                <v-select
                  v-model="day"
                  :items="days"
                  item-text="days"
                  item-value="days"
                  outlined
                  class="rounded-xl"
                  dense
                  @change="dateFilter(day)"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                sm3
                md2
                text-left
                pa-1
                v-if="day == 'Custom'"
                style="font-family: poppinsregular"
              >
                <span style="font-family: kumbhRegular; font-size: 14px"
                  >Pick from date</span
                >
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormattedFrom"
                      outlined
                      class="rounded-xl"
                      clearable
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm3
                md2
                text-left
                pa-1
                v-if="day == 'Custom'"
                style="font-family: poppinsregular"
              >
                <span style="font-family: kumbhRegular; font-size: 14px"
                  >Pick to date</span
                >
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormattedTo"
                      outlined
                      class="rounded-xl"
                      clearable
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm3
                md3
                lg2
                xl2
                pa-1
                pt-9
                text-left
                style="font-family: poppinsregular"
              >
                <v-btn
                  style="
                    font-family: kumbhBold;
                    text-transform: capitalize;
                    font-size: 14px;
                  "
                  dark
                  block
                  class="rounded-xl"
                  color="#005f32"
                  @click="eachEmployee()"
                >
                  Excel Download
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start pa-5 v-if="attendanceArray.length > 0">
          <v-flex xs12>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Attendance Date
                    </th>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Punch in
                    </th>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Punch out
                    </th>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Work Hours
                    </th>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <tr
                    class="text-left align-center"
                    v-for="(item, i) in attendanceArray"
                    :key="i"
                  >
                    <td>
                      <span v-if="item.date" style="font-family: kumbhMedium">{{
                        item.date
                      }}</span>
                    </td>

                    <td>
                      <span
                        v-if="item.login && item.login != 'Not Marked'"
                        style="font-family: kumbhMedium"
                        >{{ convertUTCToLocal(item.login) }}</span
                      >
                      <span
                        v-if="item.login && item.login == 'Not Marked'"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.login }}</span
                      >
                    </td>

                    <td>
                      <span
                        v-if="item.logout && item.logout != 'Not Marked'"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ convertUTCToLocal(item.logout) }}</span
                      >
                      <span
                        v-if="item.logout && item.logout == 'Not Marked'"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.logout }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.workedHours"
                        style="font-family: kumbhMedium"
                        >{{ item.workedHours }}</span
                      >
                    </td>
                    <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left pa-2>
                          <v-dialog
                            v-model="item.view"
                            persistent
                            max-width="70%"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                title="View"
                                color="#005f32"
                                v-on="on"
                                @click="getView(item)"
                                v-bind="attrs"
                                >mdi-eye</v-icon
                              >
                            </template>
                            <v-card>
                              <v-layout wrap>
                                <v-flex
                                  xs12
                                  align-self-center
                                  pa-4
                                  style="background: #005f32"
                                  text-left
                                >
                                  <v-layout wrap>
                                    <v-flex xs11>
                                      <span
                                        class="kumbhBold"
                                        style="color: #ffffff"
                                        >ATTENDANCE DETAILS</span
                                      >
                                    </v-flex>
                                    <v-flex xs1 text-right>
                                      <v-icon
                                        color="white"
                                        @click="
                                          (item.view = false), clearData()
                                        "
                                        >mdi-close</v-icon
                                      >
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex
                                  xs12
                                  align-self-center
                                  class="kumbhRegular"
                                >
                                  <v-layout wrap pa-4>
                                    <v-flex
                                      xs12
                                      v-for="info in data"
                                      :key="info._id"
                                    >
                                      <v-timeline
                                        :dense="$vuetify.breakpoint.smAndDown"
                                      >
                                        <v-timeline-item
                                          v-if="info.attendanceType == 'login'"
                                          color="#005f32"
                                          fill-dot
                                          right
                                        >
                                          <span
                                            slot="opposite"
                                            style="
                                              font-family: kumbhMedium;
                                              color: black;
                                            "
                                          >
                                            Punch In
                                            <br />
                                            <br />
                                            <span
                                              style="
                                                font-size: 16px;
                                                font-family: kumbhSemibold;
                                              "
                                            >
                                              {{
                                                convertUTCToLocal(
                                                  info.attendanceTime
                                                )
                                              }}</span
                                            ></span
                                          >
                                          <v-card>
                                            <v-card-title
                                              style="background-color: #005f32"
                                            >
                                            </v-card-title>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="10"
                                                  class="text-left"
                                                >
                                                  <span v-if="info.address"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address: </span
                                                    >{{ info.address }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.city"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >City: </span
                                                    >{{ info.city }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.state"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >State: </span
                                                    >{{ info.state }}</span
                                                  >
                                                  <span
                                                    v-if="
                                                      !info.address &&
                                                      !info.city &&
                                                      !info.state
                                                    "
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address not fetched</span
                                                    >
                                                  </span>
                                                  <p
                                                    v-if="
                                                      info.description != ''
                                                    "
                                                    style="
                                                      font-size: 16px;
                                                      color: black !important;
                                                    "
                                                  >
                                                    <b>Description</b>
                                                    <span>
                                                      <br />
                                                      {{
                                                        info.description.slice(
                                                          0,
                                                          100
                                                        )
                                                      }}
                                                    </span>
                                                  </p>
                                                  <div
                                                    v-if="
                                                      info.photos &&
                                                      info.photos.length
                                                    "
                                                  >
                                                    <b>Images</b><br />
                                                    <v-chip
                                                      v-for="(
                                                        photo, index
                                                      ) in info.photos"
                                                      :key="index"
                                                      color="#b1fad9"
                                                      class="ma-1"
                                                    >
                                                      {{ photo }}
                                                      &nbsp;<v-icon
                                                        class="mt-1"
                                                        small
                                                        @click="
                                                          openImageDialog(photo)
                                                        "
                                                        >mdi-eye</v-icon
                                                      >
                                                    </v-chip>
                                                  </div>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card>
                                        </v-timeline-item>
                                        <v-timeline-item
                                          v-if="info.attendanceType == 'other'"
                                          color="#005f32"
                                          fill-dot
                                          right
                                        >
                                          <span
                                            slot="opposite"
                                            style="
                                              font-family: kumbhMedium;
                                              color: black;
                                            "
                                          >
                                            <br />
                                            <br />
                                            <span
                                              style="
                                                font-size: 16px;
                                                font-family: kumbhSemibold;
                                              "
                                            >
                                              {{
                                                convertUTCToLocal(
                                                  info.attendanceTime
                                                )
                                              }}</span
                                            ></span
                                          >
                                          <v-card>
                                            <v-card-title
                                              style="background-color: #005f32"
                                            >
                                            </v-card-title>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="10"
                                                  class="text-left"
                                                >
                                                  <span v-if="info.address"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address: </span
                                                    >{{ info.address }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.city"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >City: </span
                                                    >{{ info.city }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.state"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >State: </span
                                                    >{{ info.state }}</span
                                                  >
                                                  <span
                                                    v-if="
                                                      !info.address &&
                                                      !info.city &&
                                                      !info.state
                                                    "
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address not fetched</span
                                                    >
                                                  </span>
                                                  <p
                                                    v-if="
                                                      info.description != ''
                                                    "
                                                    style="
                                                      font-size: 16px;
                                                      color: black !important;
                                                    "
                                                  >
                                                    <b>Description</b>
                                                    <span>
                                                      <br />
                                                      {{
                                                        info.description.slice(
                                                          0,
                                                          100
                                                        )
                                                      }}
                                                    </span>
                                                  </p>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card>
                                        </v-timeline-item>
                                        <v-timeline-item
                                          v-if="info.attendanceType == 'logout'"
                                          color="#005f32"
                                          fill-dot
                                          left
                                        >
                                          <span
                                            slot="opposite"
                                            style="
                                              font-family: kumbhMedium;
                                              color: black;
                                            "
                                          >
                                            <span
                                              v-if="info.applyMode == 'auto'"
                                              >Auto Punchout</span
                                            >
                                            <span v-else> Punch Out</span>
                                            <br />
                                            <br />
                                            <span
                                              style="
                                                font-size: 16px;
                                                font-family: kumbhSemibold;
                                              "
                                            >
                                              {{
                                                convertUTCToLocal(
                                                  info.attendanceTime
                                                )
                                              }}</span
                                            ></span
                                          >
                                          <v-card>
                                            <v-card-title
                                              style="background-color: #005f32"
                                            >
                                            </v-card-title>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="10"
                                                  class="text-left"
                                                >
                                                  <span v-if="info.address"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address: </span
                                                    >{{ info.address }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.city"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >City: </span
                                                    >{{ info.city }}
                                                    <br />
                                                  </span>
                                                  <span v-if="info.state"
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >State: </span
                                                    >{{ info.state }}</span
                                                  >
                                                  <span
                                                    v-if="
                                                      !info.address &&
                                                      !info.city &&
                                                      !info.state
                                                    "
                                                    ><span
                                                      style="
                                                        font-size: 15px;
                                                        font-family: kumbhSemibold;
                                                      "
                                                      >Address not fetched</span
                                                    >
                                                  </span>
                                                  <p
                                                    v-if="
                                                      info.description != ''
                                                    "
                                                    style="
                                                      font-size: 16px;
                                                      color: black !important;
                                                    "
                                                  >
                                                    <b>Description</b>
                                                    <span>
                                                      <br />
                                                      {{
                                                        info.description.slice(
                                                          0,
                                                          100
                                                        )
                                                      }}
                                                    </span>
                                                  </p>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card>
                                        </v-timeline-item>
                                      </v-timeline>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#005f32"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout> -->
    <div v-show="attendanceArray.length > 0">
      <v-layout wrap>
        <v-flex xs12>
          <span class="itemHeading">LOCATION</span>
          <GmapMap
            :center="mapCenter"
            :zoom="15"
            style="width: 100%; height: 400px"
          >
            <GmapMarker
              v-for="(location, index) in locations"
              :key="index"
              :icon="getMarkerIcon(location)"
              :position="location.position"
              @click="showInfoWindow(location)"
            />
            <GmapInfoWindow
              :options="{
                pixelOffset: {
                  width: 0,
                  height: -35,
                },
              }"
              :position="infoWindow.position"
              :opened="infoWindow.open"
              @closeclick="infoWindow.open = false"
            >
              <div v-html="infoWindow.content"></div>
            </GmapInfoWindow>
          </GmapMap>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog persistent v-model="viewImagedialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px"
                  >View Image</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="viewImagedialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pt-2>
            <v-layout wrap px-5 pb-8 justify-center>
              <v-flex xs12 align-self-center text-center>
                <v-img
                  :src="mediaURL + selectedPhoto"
                  fill-height
                  height="60%"
                  width="60%"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px"
                  >Invalid Location</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="dialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px"
                  >Please enable location access and try again</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="remarkdialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px"
                  >Remarks</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="remarkdialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-2>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="itemValue"> Description</span>
                <v-textarea
                  class="pt-2 text-des"
                  style="font-size: 14px"
                  v-model="description"
                  outlined
                  dense
                  hide-details
                ></v-textarea>
              </v-flex>

              <v-flex pt-2 xs12 align-self-center text-left>
                <span class="itemValue"> Upload Images</span>
                <v-layout wrap justify-center pa-5 style="border: solid 1px">
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex
                        xs12
                        sm6
                        md4
                        lg4
                        pa-5
                        v-for="(items, index) in displayImage"
                        :key="index"
                      >
                        <v-img
                          :src="items"
                          fill-height
                          height="100%"
                          width="100%"
                        >
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon
                                  color="#FFF"
                                  small
                                  @click="removeImage(index)"
                                >
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn
                          color="blue-grey"
                          dark
                          small
                          @click="$refs.uploadDoc.click()"
                          class="itemform"
                          ><span> UPLOAD IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn
                        >
                      </v-flex>
                      <input
                        v-show="false"
                        id="file1"
                        ref="uploadDoc"
                        multiple
                        type="file"
                        accept=".svg, .png, .jpg, .jpeg"
                        @change="uploadDoc"
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pb-3>
            <v-btn color="#005f32" @click="submitRemark()">
              <span class="itemValue" style="color: white"> Submit </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="remarkdialogedit" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px"
                  >Edit Notes</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn
                  icon
                  color="white"
                  text
                  @click="remarkdialogedit = false"
                >
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-2>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left v-if="attendanceData">
                <span class="itemValue"> Description</span>
                <v-textarea
                  class="pt-2 text-des"
                  style="font-size: 14px"
                  v-model="attendanceData.description"
                  outlined
                  dense
                  hide-details
                ></v-textarea>
              </v-flex>

              <v-flex
                pt-2
                xs12
                align-self-center
                text-left
                v-if="attendanceData"
              >
                <span class="itemValue"> Images</span>
                <v-layout
                  wrap
                  justify-center
                  pa-5
                  style="border: solid 1px"
                  v-if="attendanceData.photos"
                >
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex
                        xs12
                        sm6
                        md4
                        lg4
                        pa-5
                        v-for="(items, index) in attendanceData.photos"
                        :key="index"
                      >
                        <v-img
                          :src="mediaURL + items"
                          fill-height
                          height="100%"
                          width="100%"
                        >
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon
                                  color="#FFF"
                                  small
                                  @click="
                                    (deleteDialogImage = true),
                                      (imgItem = items)
                                  "
                                >
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn color="blue-grey" dark small @click="$refs.uploadDoc.click()" class="itemform"><span>
                            UPLOAD IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn>
                      </v-flex>
                      <input v-show="false" id="file1" ref="uploadDoc" multiple type="file"
                        accept=".svg, .png, .jpg, .jpeg" @change="uploadDoc" />
                    </v-layout> -->
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex pt-2 xs12 align-self-center text-left>
                <span class="itemValue"> Upload Images</span>
                <v-layout wrap justify-center pa-5 style="border: solid 1px">
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex
                        xs12
                        sm6
                        md4
                        lg4
                        pa-5
                        v-for="(items, index) in displayImage"
                        :key="index"
                      >
                        <v-img
                          :src="items"
                          fill-height
                          height="100%"
                          width="100%"
                        >
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon
                                  color="#FFF"
                                  small
                                  @click="removeImage(index)"
                                >
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn
                          color="blue-grey"
                          dark
                          small
                          @click="$refs.uploadDoc.click()"
                          class="itemform"
                          ><span> UPLOAD IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn
                        >
                      </v-flex>
                      <input
                        v-show="false"
                        id="file1"
                        ref="uploadDoc"
                        multiple
                        type="file"
                        accept=".svg, .png, .jpg, .jpeg"
                        @change="uploadDoc"
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pb-3>
            <v-btn color="#005f32" @click="editSubmitRemark()">
              <span class="itemValue" style="color: white"> Submit </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteDialogImage" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Delete Image</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn
                  icon
                  color="white"
                  text
                  @click="deleteDialogImage = false"
                >
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px"
                  >Are you sure you want to delete this Image?</span
                >
              </v-flex>

              <v-flex xs11 align-self-center text-right pt-3>
                <v-btn @click="deleteImage(imgItem)" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Delete </span>
                </v-btn></v-flex
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<!-- <script src="https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"></script> -->
<script>
import axios from "axios";
// var marker;
// var marker2;
export default {
  data: () => ({
    viewImagedialog: false,
    selectedPhoto: "",
    showsnackbar: false,
    ServerError: false,
    msg: null,
    pages: 0,
    dialog: false,
    pageCount: 1,
    appLoading: false,
    currentPage: 1,
    flag: false,
    location: [],
    userId: localStorage.getItem("userid"),
    totalData: 0,
    addcat: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    attendanceArray: [],
    attendanceData: [],
    data: [],
    name: null,
    assetId: null,
    // dateFilter: new Date().toISOString().substr(0, 10),
    // date: new Date().toISOString().substr(0, 7),
    // dateFormatted: vm.formatDateMonth(new Date().toISOString().substr(0, 7)),
    // menu1: false,
    // menu2: false,
    dat: "",
    oMarker: [],
    array: [],
    place: "",
    locations: [],
    // test: this.$route.query.empid,
    mapCenter: {lat: 0, lng: 0},
    infoWindow: {
      open: false,
      position: null,
      content: "",
    },

    //filter

    menu1: false,
    menu2: false,
    menu3: false,
    fromDate: new Date(),
    toDate: new Date(),
    day: "Last 7 days",
    days: [
      "Last 7 days",
      "Last 30 days",
      "Last 3 months",
      "Last 6 months",
      "Last year",
      "Custom",
    ],
    menu: false,

    date: new Date().toISOString().substr(0, 7),
    computedDateFormatted: "",
    currentdate: new Date().toDateString(),
    hourValue: "",
    profile: {},
    isLoggedout: false,
    isLoggedin: false,
    loginTime: "",
    logoutTime: "",
    deleteDialogImage: false,
    remarkdialog: false,
    remarkdialogedit: false,
    // attendanceData: {},
    docs1: [],
    fileArray: [],
      byte: "",
      kb: "",
      mb: "",
      gb: "",
    displayImage: [],
    docs: [],
    description: "",

  }),

  mounted() {
    this.getData();
    if (this.day) {
      this.dateFilter(this.day);
    }
    // this.getList();
    this.getProfile();
  },
  computed: {
    computedDateFormattedFrom() {
      return this.formatDate(this.fromDate);
    },
    computedDateFormattedTo() {
      return this.formatDate(this.toDate);
    },
  },

  watch: {
    date() {
      this.currentPage = 1;
      this.computedDateFormatted = this.formatDateMonth(this.date);
    },
    fromDate() {
      this.getData();
    },
    toDate() {
      this.getData();
    },
    status() {
      this.currentPage = 1;
      this.getData();
    },
    currentPage() {
      this.getData();
    },
  },
  beforeMount() {
    this.computedDateFormatted = this.formatDateMonth(this.date);

    if (this.computedDateFormattedFrom) {
      this.computedDateFormattedFrom.setDate(
        this.computedDateFormattedFrom.getDate() - 7
      );
      this.computedDateFormattedFrom = this.computedDateFormattedFrom
        .toISOString()
        .substr(0, 10);
    }
    if (this.computedDateFormattedTo) {
      this.computedDateFormattedTo.setDate(
        this.computedDateFormattedTo.getDate()
      );
      this.computedDateFormattedTo = this.computedDateFormattedTo
        .toISOString()
        .substr(0, 10);
    }
  },

  methods: {
    openImageDialog(photo) {
      this.selectedPhoto = photo; // Set the clicked photo
      this.viewImagedialog = true; // Open the dialog
    },
    uploadDoc(event) {
      this.docs1 = event.target.files || event.dataTransfer.files;

      if (this.docs.length < 10) {
        for (let i = 0; i < this.docs1.length; i++) {
          if (this.fileArray.includes(this.docs1[i].name)) {
            this.msg = "Duplicate File";
            this.showSnackBar = true;
          } else {
            const urls = URL.createObjectURL(this.docs1[i]);
            this.displayImage.push(urls);
            this.docs.push(this.docs1[i]);
          }
          this.fileArray.push(this.docs1[i].name);
        }
      } else {
        this.msg = "Maximum 10 images can be uploaded";
        this.showSnackBar = true;
      }
    },
    clearForm() {
      this.description = "";
      this.displayImage = [];
      this.docs = [];
      this.fileArray = [];
    },
    removeImage(index) {
      this.displayImage.splice(index, 1);
      this.docs.splice(index, 1);
      this.fileArray.splice(index, 1);
    },
    submitRemark() {
      let formData = new FormData();

      // formData.append("attendanceId", this.$route.query._id);

      const selectedAttendance = this.atndnce.find(
        (item) => item.attendanceType === "login"
      ); // Adjust condition as needed

      // Get the _id from the selected attendance object
      const attendanceId = selectedAttendance ? selectedAttendance._id : null;
      if (!attendanceId) {
        this.msg = "No matching attendance record found.";
        this.showSnackBar = true;
        return;
      }

      formData.append("description", this.description);
      formData.append("attendanceId", attendanceId);
      for (let i = 0; i < this.docs.length; i++) {
        formData.append("photos", this.docs[i]);
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/attendance/note/update",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData, // Use the local formData object, not this.formData
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.clearForm();
            this.showSnackBar = true;
            this.remarkdialog = false;
            this.getProfile();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSubmitRemark() {
      let formData = new FormData();

      // formData.append("attendanceId", this.$route.query._id);

      const selectedAttendance = this.atndnce.find(
        (item) => item.attendanceType === "login"
      ); // Adjust condition as needed

      // Get the _id from the selected attendance object
      const attendanceId = selectedAttendance ? selectedAttendance._id : null;
      if (!attendanceId) {
        this.msg = "No matching attendance record found.";
        this.showSnackBar = true;
        return;
      }

      formData.append("description", this.attendanceData.description);
      formData.append("attendanceId", attendanceId);
      for (let i = 0; i < this.docs.length; i++) {
        formData.append("photos", this.docs[i]);
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/attendance/note/update",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData, // Use the local formData object, not this.formData
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.remarkdialogedit = false;
            this.getProfile();
            this.showSnackBar = true;
            this.description = null;
            this.docs = [];
            this.displayImage = [];
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/attendance/each/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          from: this.fromDate,
          to: this.toDate,
          id: this.$route.query.id,
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.appLoading = false;
            (this.locations = []), (this.attendanceArray = response.data.data);
            this.array = response.data.data;
            const transformedData = response.data.data.map((item) => ({
              type: "login", // Assuming type for example purposes
              position: {
                lat: item.loginLocation.location[1],
                lng: item.loginLocation.location[0],
              },
              time: item.login,
              address: item.loginLocation.address,
              city: item.loginLocation.city,
              state: item.loginLocation.state,
              punchDate: item.date,
              employee: item.uid,
            }));

            // Concatenate logout locations if needed
            response.data.data.forEach((item) => {
              transformedData.push({
                type: "logout",
                position: {
                  lat: item.logoutLocation.location[1],
                  lng: item.logoutLocation.location[0],
                },
                time: item.logout,
                address: item.logoutLocation.address,
                city: item.logoutLocation.city,
                state: item.logoutLocation.state,
                punchDate: item.date,
                employee: item.uid,
              });
            });

            this.locations = transformedData;
            if (transformedData.length > 0) {
              this.mapCenter = transformedData[0].position;
            }
          } else {
            // Handle error or empty response
            this.appLoading = false;
            console.error("Failed to fetch data:", response.data.msg);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    submit(item) {
      console.log("data", item, " lon", this.lon, "lat", this.lat);
      if (!this.lon || !this.lat) {
        this.dialog = true;
      } else {
        axios({
          method: "POST",
          url: "/attendance/mark",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            // description: this.note,
            attendanceType: item,
            lon: this.lon,
            lat: this.lat,
            city: this.city,
            state: this.state,
            address: this.address,
            isWebsite: true,
          },
        })
          .then((response) => {
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.getProfile();
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((e) => {
            this.visible = false;
            this.errors.push(e);
            this.msg = "failed";
          });
      }
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/employee/profile/me",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          isAttendance: true,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.profile = response.data;
            this.atndnce = response.data.atndnce;
            localStorage.setItem("isloggedin", response.data.isLoggedin);
            this.isLoggedout = response.data.isLoggedout;
            this.isLoggedin = response.data.isLoggedin;
            this.loginTime = response.data.loginTime;
            this.logoutTime = response.data.logoutTime;
            this.attendanceData = this.atndnce.find(
              (item) => item.attendanceType === "login"
            ); // Adjust condition as needed

            // var start = new Date(this.loginTime).getTime() - 5.5 * 60 * 60000;
            // var end = new Date().getTime();
            var start = new Date(this.loginTime).getTime();
            var end = new Date().getTime();
            if (this.logoutTime != "")
              end = new Date(this.logoutTime).getTime();
            // end = new Date(this.logoutTime).getTime() - 5.5 * 60 * 60000;

            var hours = (end - start) / 3600 / 1000;
            console.log("time: ", new Date(this.loginTime), new Date());
            console.log("hours: ", hours);
            this.hr = end - start;
            console.log("ens and start", this.hr);
            // var timespan = 3196683;
            if (this.hr) {
              this.hourValue = this.msToHMS(this.hr);
            } else {
              this.hourValue = 0;
            }
            console.log("result", this.hourValue);
            var newValue = 100 / 8;
            this.value1 = hours * newValue;
            if (this.value1 > 99) {
              this.value1 = 99;
            }
            localStorage.setItem(
              "orgid",
              response.data.data.organisationID._id
            );
            localStorage.setItem("userid", response.data.data._id);
            this.level = response.data.data.level;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    deleteImage(imgItem) {
      this.appLoading = true;

      axios({
        method: "POST",
        url: "/resource/image/delete/single",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          photo: imgItem,    // image being deleted
          id: this.imgItemId // id of the item containing the image
        },
      })
        .then((response) => {
          if (response.data.status) {
            // Remove the deleted image from the editingitem.photo array
            this.editingitem.photo = this.editingitem.photo.filter(
              (photo) => photo !== imgItem
            );

            this.appLoading = false;
            this.showSnackBar = true;
            this.deleteDialogImage = false;
            this.getData(); // Optionally refresh the data from the server
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    eachEmployee() {
      axios({
        method: "POST",
        url: "/attendance/each/list/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          from: this.fromDate,
          to: this.toDate,
          id: this.$route.query.id,
        },
        responseType: "blob", // Specify the response type as blob
      })
        .then((response) => {
          // Ensure the correct MIME type for Excel files
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          // Create a temporary anchor element
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.target = "_blank"; // Open in a new tab
          anchor.download = "Employee_Attendance_Report.xlsx"; // Set the file name

          // Programmatically click on the anchor to download the file
          anchor.click();

          // Clean up
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    // getList() {
    //   var data1 = {};
    //   data1["id"] = this.$route.query.id;
    //   // You may need to adjust the date formatting based on your requirements
    //   if (this.computedDateFormatted !== "") {
    //     data1["month"] = this.computedDateFormatted;
    //   }
    //   axios({
    //     method: "POST",
    //     url: "/attendance/each/list",
    //     data: data1,
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status === true) {
    //         this.attendanceArray = response.data.data;
    //         this.array = response.data.data;
    //         const transformedData = response.data.data.map((item) => ({
    //           type: "login", // Assuming type for example purposes
    //           position: {
    //             lat: item.loginLocation.location[1],
    //             lng: item.loginLocation.location[0],
    //           },
    //           time: item.login,
    //           address: item.loginLocation.address,
    //           city: item.loginLocation.city,
    //           state: item.loginLocation.state,
    //           punchDate: item.date,
    //           employee: item.uid,
    //         }));

    //         // Concatenate logout locations if needed
    //         response.data.data.forEach((item) => {
    //           transformedData.push({
    //             type: "logout",
    //             position: {
    //               lat: item.logoutLocation.location[1],
    //               lng: item.logoutLocation.location[0],
    //             },
    //             time: item.logout,
    //             address: item.logoutLocation.address,
    //             city: item.logoutLocation.city,
    //             state: item.logoutLocation.state,
    //             punchDate: item.date,
    //             employee: item.uid,
    //           });
    //         });

    //         this.locations = transformedData;
    //         if (transformedData.length > 0) {
    //           this.mapCenter = transformedData[0].position;
    //         }
    //       } else {
    //         // Handle error or empty response
    //         console.error("Failed to fetch data:", response.data.msg);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching data:", error);
    //     });
    // },
    showInfoWindow(location) {
      this.infoWindow.position = location.position;
      if (location === undefined) {
        this.place = "Address not fetched";
      } else {
        if (!location.address && !location.city && !location.state) {
          this.place = "Address not fetched";
        } else {
          this.place =
            (location.address || "") +
            " " +
            (location.city || "") +
            " " +
            (location.state || "");
        }
      }
      var type = "";
      if (location.type == "login") type = "Punch In";
      else type = "Punch Out";
      this.infoWindow.content = `
        <div>
          <h4>${type}</h4>
          </br>
          <span>Date: ${location.punchDate}</span></br>
          <span>Time: ${this.convertUTCToLocal(location.time)}</span></br>
          <span>Address: ${this.place}</span>
        </div>
      `;
      this.infoWindow.open = true;
    },
    getMarkerIcon(location) {
      // Define your logic for choosing different colored icons
      if (location.type === "login") {
        return "http://maps.google.com/mapfiles/ms/icons/green-dot.png"; // URL to your custom marker icon
      } else {
        return "http://maps.google.com/mapfiles/ms/icons/red-dot.png"; // URL to your default marker icon
      }
    },
    getView(item) {
      var dt, day, year, strTime, month;
      var ss = item.date;
      item.date = ss.split("-").reverse().join("-");
      console.log(item.date);

      dt = new Date(item.date);
      day = dt.getDate();
      month = dt.getMonth() + 1;
      year = dt.getFullYear();
      year = year.toString();
      // year = year.slice(2, 4)
      strTime = year + "-" + month + "-" + day;
      this.dat = strTime;
      axios({
        url: "/employee/attendance/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item.uid,
          date: this.dat,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.data = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    clearData() {
      (this.data = []), this.getData();
    },
    convertUTCToLocalForPunchIn(utcDateString) {
      // Create a new Date object from the UTC date string
      var utcDate = new Date(utcDateString);
      const hours = utcDate.getHours();
      const minutes = utcDate.getMinutes().toString().padStart(2, "0");
      const amPm = hours >= 12 ? "PM" : "AM";

      // Adjust hours for 12-hour format (convert from 24-hour to 12-hour)
      const adjustedHours = hours % 12 || 12;

      // Format the time string (HH:MM AM/PM)
      const formattedTime = `${adjustedHours}:${minutes} ${amPm}`;

      // Return the date and time as separate objects
      return formattedTime;
    },
    convertUTCToLocal(utcDateString) {
      var utcDate = new Date(utcDateString);
      const hours = utcDate.getHours();
      const minutes = utcDate.getMinutes().toString().padStart(2, "0");
      const seconds = utcDate.getSeconds().toString().padStart(2, "0");
      //   const amPm = hours >= 12 ? "PM" : "AM";

      // Adjust hours for 12-hour format (convert from 24-hour to 12-hour)
      const adjustedHours = hours % 12 || 12;

      // Format the time string (HH:MM AM/PM)
      const formattedTime = `${adjustedHours}:${minutes}:${seconds}`;

      // Return the date and time as separate objects
      return formattedTime;
      // return {
      //   date: formattedDate,
      //   time: formattedTime
      // };
    },

    // filter
    dateFilter(day) {
      var to = new Date();
      var from = new Date(to.getTime());
      if (day == "Last 7 days") {
        from = from.setDate(from.getDate() - 7);
        from = new Date(from);
      } else if (day == "Last 30 days") {
        from = from.setDate(from.getDate() - 30);
        from = new Date(from);
      } else if (day == "Last 3 months") {
        from = from.setMonth(from.getMonth() - 3);
        from = new Date(from);
      } else if (day == "Last 6 months") {
        from = from.setMonth(from.getMonth() - 6);
        from = new Date(from);
      } else if (day == "Last year") {
        from = from.setMonth(from.getMonth() - 12);
        from = new Date(from);
      }
      // else if (day == "Lifetime") {
      //   from = "";
      //   to = "";
      // }
      this.fromDate = from.toISOString().substr(0, 10);
      this.toDate = to.toISOString().substr(0, 10);
      this.getData();
    },
    checkDate() {
      // let ndate = new Date().toISOString().substr(0, 10);
      // if (this.fromDate == ndate) {

      var m = new Date(this.fromDate);
      // var j = new Date(this.fromDate);
      var n = new Date(this.toDate);
      if (m <= n && n >= m) {
        const tomorrow = new Date(this.toDate);
        tomorrow.setDate(tomorrow.getDate() - 15);
        // this.fromDate = tomorrow.toISOString().substr(0, 10);
        // }
        // n.setDate(j.getDate() + 13);
        if (n - m < 1296000000) {
          // console.log("GH");
          // console.log("M=", m);
          // console.log("N=", n);
          // console.log("res", n - m);
          n.setDate(n.getDate());
          // console.log("Ms=", m.toISOString().substr(0, 10));
          // console.log("Ns=", n.toISOString().substr(0, 10));
          this.toDate = n.toISOString().substr(0, 10);
          // console.log("GH", this.fromDate);
          this.getData();
        } else {
          // console.log("els casssse");
          // console.log(m);
          // console.log(n);
          m.setMonth(n.getMonth());
          m.setFullYear(n.getFullYear());
          m.setDate(n.getDate() - 15);
          // n.setMonth(m.getMonth());
          // n.setFullYear(m.getFullYear());
          // n.setDate(m.getDate() + 15);
          // console.log("fin", n);
          // console.log("Msss=", m.toISOString().substr(0, 10));
          // console.log("Nsss=", n.toISOString().substr(0, 10));
          // console.log("els case", m.getMonth());
          this.fromDate = m.toISOString().substr(0, 10);
          this.toDate = n.toISOString().substr(0, 10);
          this.getData();
        }
      } else {
        n.setMonth(m.getMonth());
        n.setFullYear(m.getFullYear());
        n.setDate(m.getDate() + 15);
        this.toDate = n.toISOString().substr(0, 10);
        this.getData();
      }
    },
    checkDate1() {
      var m = new Date(this.fromDate);
      var n = new Date(this.toDate);
      if (m <= n && n >= m) {
        if (n - m < 1296000000) {
          // console.log("GH");
          // console.log("M=", m);
          // console.log("N=", n);
          // console.log("res", n - m);
          n.setDate(n.getDate());
          // console.log("Ms=", m.toISOString().substr(0, 10));
          // console.log("Ns=", n.toISOString().substr(0, 10));
          this.toDate = n.toISOString().substr(0, 10);
          // console.log("GH", this.fromDate);
          this.getData();
        } else {
          // console.log("els casssse");
          // console.log(m);
          // console.log(n);
          n.setMonth(m.getMonth());
          n.setFullYear(m.getFullYear());
          n.setDate(m.getDate() + 7);
          // m.setMonth(n.getMonth());
          // m.setFullYear(n.getFullYear());
          // m.setDate(n.getDate() - 15);
          // console.log("fin", m);
          // console.log("els case", n.getMonth());
          this.fromDate = m.toISOString().substr(0, 10);
          this.toDate = n.toISOString().substr(0, 10);
          this.getData();
        }
      } else {
        m.setMonth(n.getMonth());
        m.setFullYear(n.getFullYear());
        m.setDate(n.getDate() - 7);
        this.fromDate = m.toISOString().substr(0, 10);

        this.getData();
      }
    },
    formatDate(item) {
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
    msToHMS(ms) {
      var seconds = ms / 1000;
      var hrs = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
      hrs = hrs < 10 ? "0" + hrs : hrs;
      seconds = seconds % 3600; // seconds remaining after extracting hrs
      var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds % 60;
      return hrs + " : " + minutes;
    },
    formatDateMonth(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}-${year}`;
    },
    formatDatePicker(date) {
      var dt = new Date(date);
      var day = String(dt.getDate()).padStart(2, "0"); // Ensure two digits
      var month = String(dt.getMonth() + 1).padStart(2, "0"); // Ensure two digits
      var year = dt.getFullYear();
      var strTime = day + "-" + month + "-" + year;
      return strTime;
    },
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}

#map {
  height: 400px !important;
  width: 100%;
}
</style>
      
